<template>
    <div class="accountData">
        <Page :renderSearchList="renderList" :searchData="searchData" :tableData="tableData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @changePageSize="handleChangePageSize" @changeSearchDat="handleChangeSearchData" @search="handleSearch">
            <div class="table-content" ref="tableContent" :style="`height: ${tableHeight}px`">
                <Table :data="tableData" size="medium" stripe v-if="tableData.length && !isLoading" :height="tableHeight">
                    <el-table-column prop="goodsId" label="商品推广ID" min-width="60"></el-table-column>
                    <el-table-column prop="status" label="状态" min-width="40">
                        <template slot-scope="scope">
                            <div>
                                <span style="color: #67c23a" v-if="scope.row.status == 1">推广中</span>
                                <span style="color: #FF003C" v-else-if="scope.row.status == 2">已关闭</span>
                                <span v-else>--</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="platName" label="电商平台" min-width="40"></el-table-column>
                    <el-table-column prop="adReportOrderStatus" label="推广目标" min-width="40">
                        <template slot-scope="scope">
                            <div>{{scope.row.adReportOrderStatus == 1 ? '下单' : (scope.row.adReportOrderStatus == 2 ? '支付' : '--')}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="adPlatName" label="引流平台" width="80"></el-table-column>
                    <el-table-column prop="goodsName" label="商品名称" min-width="80"></el-table-column>
                    <el-table-column prop="platGoodsLink" label="商品链接" min-width="80"></el-table-column>
                    <el-table-column prop="notes" label="备注" min-width="40"></el-table-column>
                </Table>

                <div class="table-normal" v-if="!tableData.length && !isLoading">
                    <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                    <span>目前暂无数据</span>
                </div>

                <div v-if="isLoading">
                    <Loading></Loading>
                </div>
            </div>
        </Page>

        <div :class="`accountData-mobile`">
            <PageMobile title="商品信息" :renderSearchList="renderMobileList" :searchData="searchData" :total="total" :current="current" :pageSize="pageSize" @changeCurrrent="handleChangeCurrrent" @search="handleSearch">
                <div class="table-content" ref="tableContentMobile" :style="`height: ${tableHeight}px`">
                    <Table :data="tableData" size="small" :height="tableHeight" stripe v-if="tableData.length && !isLoading">
                        <el-table-column prop="goodsId" label="商品推广ID" width="130"></el-table-column>
                        <el-table-column prop="status" label="状态" width="80">
                            <template slot-scope="scope">
                                <div>
                                    <span style="color: #67c23a" v-if="scope.row.status == 1">推广中</span>
                                    <span style="color: #FF003C" v-else-if="scope.row.status == 2">已关闭</span>
                                    <span v-else>--</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="platName" label="电商平台" width="80"></el-table-column>
                        <el-table-column prop="adReportOrderStatus" label="推广目标" width="80">
                            <template slot-scope="scope">
                                <div>{{scope.row.adReportOrderStatus == 1 ? '下单' : (scope.row.adReportOrderStatus == 2 ? '支付' : '--')}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="adPlatName" label="引流平台" width="80"></el-table-column>
                        <el-table-column prop="goodsName" label="商品名称" width="120"></el-table-column>
                        <el-table-column prop="platGoodsLink" label="商品链接" width="120"></el-table-column>
                        <el-table-column prop="notes" label="备注" width="80"></el-table-column>
                    </Table>

                    <div class="table-normal" v-if="!tableData.length && !isLoading">
                        <img src="@/assets/home/dataEffect/accountData/default_img_no_data.png" alt="">
                        <span>目前暂无数据</span>
                    </div>

                    <div v-if="isLoading">
                        <Loading></Loading>
                    </div>
                </div>
            </PageMobile>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import Page from '@/components/page/page.vue'
import PageMobile from '@/components/pageMobile/pageMobile.vue'
import Icon from 'iview/src/components/icon';
import { Table, TableColumn } from 'element-ui';
import Loading from '@/components/loading/loading.vue'
Vue.use(Table)
Vue.use(TableColumn)
import { renderList, renderMobileList } from './config'
import moment from 'moment'
export default {
    components: {
        Page,
        Icon,
        Table,
        Loading,
        PageMobile
    },
    data() {
        return {
            renderList: renderList,
            renderMobileList: renderMobileList,
            tableData: [],
            searchData: {},
            isLoading: true,
            tableTotalData: {},
            total: 0,
            pageSize: 15,
            current: 1,
            tableHeight: ""
        }
    },
    filters: {
        filtersCell(value) {
            if (value) {
                return value
            } else {
                return '-'
            }
        }
    },
    mounted() {
        if (window.innerWidth > 768) {
            this.tableHeight = this.$refs.tableContent ? this.$refs.tableContent.offsetHeight : ""
        } else {
            this.tableHeight = this.$refs.tableContentMobile ? this.$refs.tableContentMobile.offsetHeight : ""
        }
        this.getTableData()
    },
    methods: {
        // 获取商品数据
        getTableData() {
            this.isLoading = true
            this.$axios({
                url: '/api/syn/rebateDataPlat/goods/list',
                data: {
                    ...this.searchData,
                    current: this.current,
                    pageSize: this.pageSize
                },
                method: 'GET'
            }).then((res) => {
                this.tableData = res.Data.data || []
                this.total = res.Data.total
                this.$nextTick(() => {
                    this.isLoading = false
                })
            })
        },

        // 处理移动端搜索改变事件
        handleChangeSearchMobileData(data) {
            const currData = { ...data }
            delete currData.dates
            this.searchData = {
                ...currData
            }
        },

        // 处理搜索事件
        handleSearch() {
            this.current = 1
            this.getTableData()
        },

        // 当前页改变时触发
        handleChangeCurrrent(current) {
            this.current = current
            this.getTableData()
        },

        // pageSize改变时触发
        handleChangePageSize(pageSize) {
            this.current = 1
            this.pageSize = pageSize
            this.getTableData()
        },

        // 处理搜索框改变时触发
        handleChangeSearchData(eventData) {
            const { data, item } = eventData
            this.searchData = data
        }
    }
}
</script>

<style lang="scss" scoped>
@media screen and (min-width: 768px) {
    .accountData {
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        padding: 20px;
        background-color: #fff;
        .accountData-mobile {
            display: none;
        }
        .accountData-content {
            flex: 1;
        }
        .accountData-bottom {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 0;
        }
    }
}

@media screen and (max-width: 768px) {
    .accountData {
        height: 100%;
        display: flex;
        flex-direction: column;
        padding: 1.1rem 0 0;
        background-color: #f7f7f7;
        .wf-page {
            display: none;
        }
        .accountData-content {
            flex: 1;
        }
        .accountData-mobile {
            min-height: 100%;
            display: block;
            display: flex;
            flex-direction: column;
            padding: 0 0.3rem 0.3rem;
            overflow-y: auto;
            .table-content {
                overflow-x: auto;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/goodsInfo/goodsList/index.vue